// extracted by mini-css-extract-plugin
export var heading = "integrations-section-module--heading--cfb79";
export var inner = "integrations-section-module--inner--34e38";
export var item = "integrations-section-module--item--ce6c7";
export var root = "integrations-section-module--root--a7e64";
export var slider = "integrations-section-module--slider--3c323";